import InstantApp from '../InstantApp'
import settings from './settings'
import customFields from './customFields'
import { MOBILE_APP_LANDING } from 'constants/templateCategory'
import thumbnail from '../assets/thumbnail.jpeg'
import * as integrationType from 'constants/integrationType'

export const information = {
  id: 'appWebsite',
  title: 'App website',
  image: thumbnail,
  thumbnailPath: [ 'scene2', 'bg' ],
  category: MOBILE_APP_LANDING,
  description: 'Make a website from your existing app.',
  integrations: [ integrationType.MOBILE_APP ],
  instantApp: InstantApp,
  defaultSettings: settings,
}

export function getTemplate (app) {
  return {
    id: 'appWebsite',
    customFields,
    settings
  }
}



// WEBPACK FOOTER //
// ./src/templates/app-website/template/index.js